(function(){var form=document.getElementById('homnes-newsletter-form');var msg=document.getElementById('hms-nl-msg');if(!form||!msg)return;var posted=form.querySelector('[data-form-posted]');var errors=form.querySelector('[data-form-errors]');if(posted){msg.textContent='Merci ! Vous êtes bien inscrit·e.';msg.className='hms-nl__msg is-success';form.style.display='none';}else if(errors){msg.textContent='Une erreur est survenue. Réessayez ?';msg.className='hms-nl__msg is-error';}})();
(function(){document.querySelectorAll('.hms-faq__item').forEach(function(item){var q=item.querySelector('.hms-faq__q');if(!q)return;q.addEventListener('click',function(){item.classList.toggle('is-open');});});})();
(function(){
var SEL = '.hms-presse, .hms-best, .hms-diag-big, .hms-avis, .hms-nl, .hms-faq, .hms-reass';
function show(){
document.querySelectorAll(SEL).forEach(function(el){
el.classList.add('hms-is-visible');
el.style.setProperty('opacity', '1', 'important');
el.style.setProperty('transform', 'none', 'important');
el.style.setProperty('transition', 'none', 'important');
});
}
if(document.readyState === 'loading'){
document.addEventListener('DOMContentLoaded', show);
} else {
show();
}
})();
(function(){
var BLUE = '#000b8c';
var css = '.hms-presse{background:' + BLUE + ' !important;border-bottom:none !important}'
+ '.hms-presse__label{color:#ffffff !important}'
+ '.hms-presse__logo{filter:brightness(0) invert(1) !important;opacity:1 !important}'
+ '.hms-nl__title,.hms-nl__sub,.hms-nl__legal,.hms-nl__msg{color:' + BLUE + ' !important}'
+ '.hms-reass__title,.hms-reass__desc,.hms-reass__desc a{color:' + BLUE + ' !important}'
+ '.hms-reass__icon{color:' + BLUE + ' !important}'
+ ':root{--color-background-button-contrast:#ffffff !important}'
+ '.btn--primary,.btn--primary *,.cart__checkout,.cart__checkout *,button[name="checkout"],.cart__ctas .btn,.cart__ctas button,.quick-add__submit,.product-form__cart-submit,.cart__update{color:#ffffff !important}'
+ '.cart-count-bubble{background:' + BLUE + ' !important}'
+ '.cart-count-bubble span,.cart-count-bubble *{color:#ffffff !important}'
+ 'body.template-index .header .cart-count-bubble{background:' + BLUE + ' !important}'
+ 'body.template-index .header .cart-count-bubble span,body.template-index .header .cart-count-bubble *{color:#ffffff !important}'
+ '.header__cart-count,.header__cart-count span,[data-js-cart-count]{color:#ffffff !important}'
+ 'body.template-index .header .header__cart-count,body.template-index .header .header__cart-count span,body.template-index .header [data-js-cart-count]{color:#ffffff !important}'
+ '.localization-form__select,.localization-form__select *,.localization-form .disclosure__button,.localization-form .disclosure__button *,.localization-form button,.localization-form button *{color:#ffffff !important}'
+ '.header__right .header__icon-touch--account{margin-right:10px !important}'
+ '.header__right .hms-loc__trigger{margin-left:16px !important;margin-right:12px !important;position:relative;z-index:3}'
+ '@media(max-width:749px){.header__right .header__icon-touch--account{margin-right:6px !important}.header__right .hms-loc__trigger{margin-left:10px !important;margin-right:8px !important}}'
+ '.quick-purchase-bar .share-icons,.quick-purchase-bar__purchase .share-icons{display:none !important}'
+ '.hms-best__sub{color:#000b8c !important;opacity:1 !important;font-size:12px !important;font-weight:600 !important}';
var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
function whiteLogos(){
document.querySelectorAll('.hms-presse__logo').forEach(function(img){
img.style.setProperty('background-color', '#ffffff', 'important');
});
}
var NEWTXT = 'Laboratoire sensoriel niché en plein cœur du Marais. Poussez la porte : diagnostic capillaire, conseils sur-mesure et toute la gamme vous y attendent.';
function fixMarais(){
var m = document.querySelector('.hms-marais'); if(!m) return;
var t = m.querySelector('.hms-marais__text');
if(t && t.textContent.indexOf('Laboratoire sensoriel') !== 0){ t.textContent = NEWTXT; }
var nl = document.querySelector('.hms-nl'); if(!nl) return;
var anchor = nl.closest('.shopify-section') || nl;
if(anchor.parentNode && anchor.previousElementSibling !== m){ anchor.parentNode.insertBefore(m, anchor); }
}
function tick(){ whiteLogos(); fixMarais(); }
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', tick); } else { tick(); }
[400, 900, 1700, 2600].forEach(function(ms){ setTimeout(tick, ms); });
})();
(function(){
var country = (window.Shopify && Shopify.country) ? String(Shopify.country).toUpperCase() : null;
if(country !== 'CH') return;
var lang = (document.documentElement.lang || 'fr').slice(0,2).toLowerCase();
var TXT = {
fr: 'Expédié depuis la Suisse · aucuns frais de douane.',
de: 'Versand aus der Schweiz · keine Zollgebühren.',
it: 'Spedito dalla Svizzera · nessuna spesa doganale.',
en: 'Shipped from Switzerland · no customs fees.',
es: 'Enviado desde Suiza · sin gastos de aduana.'
};
function mk(){
if(!document.body || document.querySelector('.hms-ch-bar')) return true;
var b = document.createElement('div');
b.className = 'hms-ch-bar';
b.setAttribute('style','background:#000b8c;color:#f4f2e7;text-align:center;font-family:\'Anybody\',sans-serif;font-weight:700;font-size:12px;letter-spacing:.04em;padding:9px 16px;line-height:1.3;');
b.textContent = '🇨🇭 ' + (TXT[lang] || TXT.fr);
document.body.insertBefore(b, document.body.firstChild);
return true;
}
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', mk); } else { mk(); }
setTimeout(mk, 800);
})();
(function(){
var me = document.currentScript;
var lang = (document.documentElement.lang || 'fr').slice(0,2).toLowerCase();
if (lang === 'fr') return;
function load(){
if (!document.body || !document.body.classList.contains('template-index')) return;
if (window.__hmsHomeI18n) return; window.__hmsHomeI18n = true;
var src = (me && me.src) ? me.src : '';
if (!src){ var ss = document.querySelectorAll('script'); for (var i=ss.length-1;i>=0;i--){ if ((ss[i].src||'').indexOf('homnes-home.js')>=0){ src = ss[i].src; break; } } }
var base = src.replace(/homnes-home\.js.*$/, '');
var s = document.createElement('script'); s.src = base + 'homnes-home-i18n.js'; s.defer = true; document.head.appendChild(s);
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', load); } else { load(); }
})();
(function(){
function fix(){
if (!document.querySelector('.homnes-duo')) return; 
if (document.getElementById('hms-compl-fix')) return;
var st = document.createElement('style'); st.id = 'hms-compl-fix';
st.textContent = '.complementary-products .product-item__image img,.complementary-products .image__img,.complementary-products img{object-fit:contain !important;background:#f4f2e7 !important;transform:none !important;opacity:1 !important;}'
+ '.complementary-products .product-item__media>div[style*="position:absolute"]{display:none !important;}';
document.head.appendChild(st);
}
if (document.readyState !== 'loading') { fix(); } else { document.addEventListener('DOMContentLoaded', fix); }
[600, 1500].forEach(function(ms){ setTimeout(fix, ms); });
})();
(function(){
function isBlue(c){ return c === 'rgb(0, 11, 140)'; }
function whiten(){
var cc = document.querySelectorAll('.header__cart-count, .header__cart-count *, [data-js-cart-count], .cart-count-bubble, .cart-count-bubble *');
for (var c = 0; c < cc.length; c++){ cc[c].style.setProperty('color', '#ffffff', 'important'); }
var all = document.querySelectorAll('a,button,div,span,li,p,strong,small,h1,h2,h3,h4,label,[class*="btn"],[class*="button"],[class*="cart"],[class*="count"],[class*="badge"],[class*="bubble"]');
for (var i = 0; i < all.length; i++){
var el = all[i];
if (el.getAttribute('data-hms-blue') === '1') continue;
var bg;
try { bg = getComputedStyle(el).backgroundColor; } catch(e){ continue; }
if (isBlue(bg)){
el.setAttribute('data-hms-blue', '1');
el.style.setProperty('color', '#ffffff', 'important');
var kids = el.querySelectorAll('*');
for (var j = 0; j < kids.length; j++){ kids[j].style.setProperty('color', '#ffffff', 'important'); }
}
}
}
if (document.readyState !== 'loading') { whiten(); } else { document.addEventListener('DOMContentLoaded', whiten); }
[500, 1200, 2500].forEach(function(ms){ setTimeout(whiten, ms); });
document.addEventListener('click', function(){ setTimeout(whiten, 300); setTimeout(whiten, 900); });
})();
(function(){
function build(){
var page = document.querySelector('.cart.page'); 
if (!page) return;
var realBtn = page.querySelector('input[name="checkout"], button[name="checkout"]');
if (!realBtn) return; 
if (document.querySelector('.hms-cart-sticky')) return;
var totalEl = document.querySelector('.cart__footer-right .ff-heading.fs-heading-4-base');
var total = totalEl ? totalEl.textContent.replace(/\s+/g, ' ').trim() : '';
var bar = document.createElement('div');
bar.className = 'hms-cart-sticky';
bar.setAttribute('data-hms-blue', '1'); 
bar.setAttribute('style', 'position:fixed;left:0;right:0;bottom:0;z-index:9998;background:#000b8c;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:12px 16px;box-shadow:0 -4px 18px rgba(0,0,0,0.18);');
var label = document.createElement('span');
label.setAttribute('style', "font-family:'Anybody',sans-serif;font-weight:700;color:#ffffff;font-size:14px;white-space:nowrap;");
label.textContent = total ? ('Total : ' + total) : '';
var btn = document.createElement('button');
btn.type = 'button';
btn.setAttribute('style', "background:#ffffff;color:#000b8c;border:none;font-family:'Anybody',sans-serif;font-weight:800;text-transform:uppercase;letter-spacing:.08em;font-size:13px;padding:13px 30px;cursor:pointer;border-radius:0;flex:0 0 auto;");
btn.textContent = 'Commander';
btn.addEventListener('click', function(){ realBtn.click(); });
bar.appendChild(label);
bar.appendChild(btn);
document.body.appendChild(bar);
document.body.style.setProperty('padding-bottom', '76px');
}
if (document.readyState !== 'loading') { build(); } else { document.addEventListener('DOMContentLoaded', build); }
[500, 1500].forEach(function(ms){ setTimeout(build, ms); });
})();